<template>
    <div class="notolao">
        <b-navbar toggleable="lg" type="dark" variant="primary" fixed="top">
            <b-navbar-brand href="#">
                <b-icon icon="printer"></b-icon> ພີມວິຊາ
            </b-navbar-brand>
            <b-navbar-nav class="ml-auto">
                <!-- <b-nav-item-dropdown right>
                           
                            <template #button-content>
                                ພາສາ
                            </template>
                        <b-dropdown-item href="#">LA</b-dropdown-item>
                        <b-dropdown-item href="#">EN</b-dropdown-item>
                    </b-nav-item-dropdown>   -->

                <b-nav-item @click="goback()">
                    <b-icon icon="x-lg" aria-hidden="true" variant="light"></b-icon>
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>
        <div>

            <div id="viewer"></div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {

        }
    },
    methods: {
        goback() {
            this.$router.go(-1)
        },
    },
    name: 'app',

    mounted: function () {
        //console.log( window.Stimulsoft)
        //  window.Stimulsoft.Base.StiLicense.loadFromFile('license.key')
        // window.Stimulsoft.Base.StiLicense.loadFromFile("license.key"); 
        console.log('Loading Viewer view');

        console.log('Creating the report viewer with default options');
        var viewer = new window.Stimulsoft.Viewer.StiViewer(null, 'StiViewer', false);

        console.log('Creating a new report instance');

        var report = new window.Stimulsoft.Report.StiReport();

        console.log('Load report from url');
        report.loadFile('/reports/visa_printvisa.mrt');

       var dataSet = new window.Stimulsoft.System.Data.DataSet("visa");
        dataSet.readJsonFile('http://localhost:3000/visa/'+ this.$route.params.code );//one JSON object

        //this line of code added,too.
        report.dictionary.databases.clear();
        report.regData("visa", "visa", dataSet);

        //this line of code is also required.
        report.dictionary.synchronize();

        console.log('Assigning report to the viewer, the report will be built automatically after rendering the viewer');
        viewer.report = report;

        console.log('Rendering the viewer to selected element');
        viewer.renderHtml('viewer');

        console.log('Loading completed successfully!');

    }
}
</script>

<style scoped>
.content {
    margin-top: 80px;
}

.notolao {
      margin-top: 80px;
    font-family: 'Noto Sans Lao Regular', 'Phetsarath OT';
}
</style>
